new Swiper('.our-product-slider', {
  loop: true,
  speed: 1500, 
  autoplay: {
    delay: 3000,  
    disableOnInteraction: false,
    pauseOnMouseEnter: true,
  },

  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },

  breakpoints: {
    0: {
      slidesPerView: 1.4,
      spaceBetween: 20,
    },
     580: {
      slidesPerView: 2.2,
      spaceBetween: 20,
    },
     767: {
      slidesPerView: 2.4,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
  },
});
